import React, { Component } from 'react';
import L from 'mapbox.js';
import { bostonRoute } from '../geojson/racePaths.js';
import InstallWebGL from './InstallWebGL.jsx';
import './NoGlMap.css';
import {
  getAccessToken,
} from '../helpers/helpers.js';

export default class NoGlMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
    }
  }

  componentDidMount () {
    L.mapbox.accessToken = getAccessToken();
    const map = L.mapbox.map('no-gl-map').setView([42.297347071405994, -71.301182881936], 11);
    map.removeControl(map.zoomControl);
    new L.Control.Zoom({ position: 'bottomright' }).addTo(map);
    L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v9').addTo(map);

    const path = L.geoJson(bostonRoute.data, {
      style: {
        "color": '#1C3667',
        "weight": 14,
        "opacity": 0.7
      }
    }).addTo(map);

    const startLocation = L.latLng([42.22842537982214, -71.522050662983]);
    L.marker(startLocation, {
        icon: L.divIcon({
            className: 'bold-header',
            html: 'Start'
        }),
        zIndexOffset: 1000
    }).addTo(map);

    const finishLocation = [42.349792930260634, -71.07844813106881]
    L.marker(finishLocation, {
        icon: L.divIcon({
            className: 'bold-header',
            html: 'Finish'
        }),
        zIndexOffset: 1000
    }).addTo(map);

    map.fitBounds(path.getBounds());

    console.log('hello', L);
  }

  render() {
    return <InstallWebGL />;
  }
}



// WEBPACK FOOTER //
// ./src/fallback/NoGlMap.jsx